import React from 'react';
import './LandingPage.css';
import { FaMapMarkerAlt, FaClock, FaHistory, FaPhoneAlt, FaLeaf, FaUtensils } from 'react-icons/fa';
import { GiMeat, GiCow, GiPig, GiFishbone, GiChicken } from 'react-icons/gi';
import { Link } from 'react-router-dom';

const LandingPage = () => {
    const cuts = [
        { name: 'Vacuno', icon: <GiCow />, desc: 'Selección de los mejores cortes vacunos del país. Calidad y ternura garantizada en cada pieza.' },
        { name: 'Cerdo', icon: <GiPig />, desc: 'Cortes seleccionados de cerdo para tus parrilladas y cocina diaria.' },
        { name: 'Pollo', icon: <GiChicken />, desc: 'Aves frescas y una gran variedad de cortes para tus comidas saludables.' },
        { name: 'Elaborados', icon: <FaUtensils />, desc: 'Milanesas, arrollados y hamburguesas de elaboración propia con el toque de Juan.' },
        { name: 'Pescados de Río', icon: <GiFishbone />, desc: 'Lo mejor de nuestra región: Dorado, Pacú, Surubí y Bagre siempre frescos.' },
        { name: 'Búfalo y Cordero', icon: <GiMeat />, desc: 'Cortes no convencionales, magros y saludables para paladares exigentes.' }
    ];

    const branches = [
        {
            name: 'Central',
            address: 'Av. Quaranta y 115',
            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d383.23913128795033!2d-55.93570504939664!3d-27.400348034712604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9457bdc4b8f2da45%3A0x3cfa3193f37e6330!2sEstaci%C3%B3n%20De%20Carnes!5e0!3m2!1ses-419!2sar!4v1770302903536!5m2!1ses-419!2sar'
        },
        {
            name: 'Rotonda',
            address: 'Colectora Ruta 12 - Calle 45 - Nº 6782',
            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d234.5317864933278!2d-55.90259503329918!3d-27.4101533800589!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9457bf693f046a45%3A0xba4ea0e421ec4df7!2sEstacion%20de%20Carnes%20-%20Rotonda!5e0!3m2!1ses-419!2sar!4v1770303070790!5m2!1ses-419!2sar'
        },
        {
            name: 'Centro',
            address: 'Córdoba 1722 casi Bs. As.',
            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3543.2!2d-55.895!3d-27.367!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9457be0000000000%3A0x0!2sCalle%20C%C3%B3rdoba%201722%2C%20N3300%20Posadas%2C%20Misiones!5e0!3m2!1ses-419!2sar!4v1710000000002!5m2!1ses-419!2sar'
        }
    ];

    return (
        <div className="landing-container">
            {/* Hero Section */}
            <section className="hero">
                <div className="brand-container">
                    <h1 className="brand-title chalk-font">Estación de</h1>
                    <h1 className="brand-title chalk-font" style={{ marginTop: '-20px' }}>Carnes</h1>
                    <span className="brand-subtitle script-font">de Juan Buenaventura</span>
                </div>
                <p>Venta minorista de cortes seleccionados. Excelencia, frescura y sabor en cada rincón de Posadas desde 2019.</p>
                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
                    <Link to="/" className="btn btn-danger btn-lg px-5 shadow-lg bebas-font" style={{ fontSize: '1.5rem', borderRadius: '0', textDecoration: 'none' }}>
                        Ver Lista de Precios
                    </Link>
                    <a href="#sucursales" className="btn btn-outline-light btn-lg px-5 bebas-font" style={{ fontSize: '1.5rem', borderRadius: '0', textDecoration: 'none' }}>
                        Sucursales
                    </a>
                </div>
            </section>

            {/* Featured Cuts Section */}
            <section className="cuts-section">
                <div className="section-title">
                    <h2 className="bebas-font">Nuestra Variedad</h2>
                </div>
                <div className="cuts-grid">
                    {cuts.map((cut, index) => (
                        <div key={index} className="cut-card">
                            <div className="cut-icon">
                                {cut.icon}
                            </div>
                            <h3 className="bebas-font">{cut.name}</h3>
                            <p>{cut.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Maps Section */}
            <section className="maps-section" id="sucursales">
                <div className="section-title">
                    <h2 className="bebas-font">Dónde Encontrarnos</h2>
                </div>
                <div className="maps-grid">
                    {branches.map((branch, index) => (
                        <div key={index} className="branch-map-card">
                            <iframe
                                title={`Mapa de ${branch.name}`}
                                src={branch.mapUrl}
                                className="map-container"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                            <div className="branch-info">
                                <h4><FaMapMarkerAlt /> {branch.name}</h4>
                                <p>{branch.address}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Trajectory / Info Section */}
            <section className="info-section">
                <div className="info-grid">
                    <div className="info-item">
                        <div className="info-icon"><FaHistory /></div>
                        <div className="info-text">
                            <h4>Nuestra Historia</h4>
                            <p>Nacimos en 2019 con una misión clara: devolverle al barrio la calidad de la carnicería tradicional con un toque moderno y profesional.</p>
                        </div>
                    </div>
                    <div className="info-item">
                        <div className="info-icon"><FaLeaf /></div>
                        <div className="info-text">
                            <h4>Compromiso de Calidad</h4>
                            <p>Recorremos todo el país seleccionando a los mejores proveedores para garantizar que a tu mesa llegue siempre la máxima calidad y frescura.</p>
                        </div>
                    </div>
                    <div className="info-item">
                        <div className="info-icon"><FaClock /></div>
                        <div className="info-text">
                            <h4>Horarios de Atención</h4>
                            <p>Lunes a Sábados: 08:00 a 13:00 / 17:00 a 21:00 hs.</p>
                            <p>Domingos: 09:00 a 13:00 hs.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Quality Commitment / CTA */}
            <section className="quality-commitment">
                <h2 className="chalk-font">Calidad de Origen</h2>
                <p>
                    "En Estación de Carnes, cada corte es tratado con el respeto que merece.
                    Nuestra pasión por el buen asado se refleja en la ternura y el sabor de nuestros productos vacunos,
                    porcinos y nuestra exclusiva selección de búfalo y cordero."
                </p>
                <div className="mt-5">
                    <a href="https://wa.me/5493764292187" className="btn btn-success btn-lg px-5 bebas-font" style={{ fontSize: '1.8rem', borderRadius: '0' }}>
                        <FaPhoneAlt style={{ marginRight: '10px', fontSize: '1.4rem' }} /> Consultas por WhatsApp
                    </a>
                </div>
            </section>


            <footer>
                <div className="footer-logo chalk-font">Estación de Carnes</div>
                <div className="footer-location bebas-font">POSADAS | MISIONES | ARGENTINA</div>
                <p className="mt-4" style={{ fontSize: '0.8rem', opacity: 0.5 }}>
                    &copy; {new Date().getFullYear()} Estación de Carnes de Juan Buenaventura. Todos los derechos reservados.
                </p>
            </footer>
        </div>
    );
};

export default LandingPage;
